import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStorageHardLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		isInCollection,
		canUpgrade,
		canDirectBuyUpgrade,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	return Boolean(
		!isInCollection &&
		product === 'jira' &&
		edition === 'free' &&
		(canUpgrade || canDirectBuyUpgrade) &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB,
	);
}
